"use client";
import Plus from "@/icons/Plus";
import clsx from "clsx";
import Image, { ImageProps } from "next/image";
import { Suspense, lazy, useState } from "react";
import styles from "./index.module.css";

const ZoomDialog = lazy(() => import("./ZoomDialog"));

/**
 * Extension of Next Image with fill that allows zooming in on the image
 */
const ZoomImage = ({ src, className, alt, fill: _, ...rest }: ImageProps) => {
  const fill = true;
  const [zoom, setZoom] = useState(false);

  const zoomOut = () => {
    setZoom(false);
  };

  const zoomIn = () => {
    setZoom(true);
  };

  return (
    <>
      <figure
        onClick={zoom ? zoomOut : undefined}
        className={clsx(styles.zoomImageContainer, zoom && styles.zoom)}
      >
        <Image
          src={src}
          fill={fill}
          className={clsx(styles.image, className)}
          alt={alt}
          {...rest}
        />
        <button
          title="show zoomed"
          aria-hidden
          onClick={zoomIn}
          className={styles.zoomButton}
        >
          <Plus />
        </button>
      </figure>
      {zoom && (
        <Suspense>
          <ZoomDialog
            setOpen={setZoom}
            src={src}
            fill={true}
            className={clsx(styles.zoomedImage, className)}
            alt={alt}
            {...rest}
          />
        </Suspense>
      )}
    </>
  );
};

export default ZoomImage;
